import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangLvLangmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 1.125a7.875 7.875 0 1 1 0 15.75 7.875 7.875 0 0 1 0-15.75Z",
			fill: "#32AB45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.379 6.244H1.621a7.878 7.878 0 0 1 14.758 0Z",
			fill: "#FFE70E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.97 16.875a7.878 7.878 0 0 1-7.35-5.12h14.76a7.878 7.878 0 0 1-7.35 5.12h-.06Z",
			fill: "#E92B2B"
		})
	]
});
const ForwardRef = forwardRef(SvgLangLvLangmin);
export { ForwardRef as ReactComponent };
